/*
 *
 * AllEvents constants
 *
 */

export const SLICE_NAME = 'allevents';
